import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function EmployeeList() {
  const [list, setList] = useState([]);

  useEffect(() => {
    fetchList();
  }, []);

  async function fetchList() {
    try {
      const res = await axios.get('https://attendance-api.elitewebpro.com/api/employees/all');
      if (res.data.success) setList(res.data.employees);
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div>
      <h3>Employees</h3>
      <table border="1" cellPadding="6" style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Image</th>
            <th>QR Code</th>
          </tr>
        </thead>
        <tbody>
          {list.map(emp => (
            <tr key={emp.id}>
              <td>{emp.id}</td>
              <td>{emp.name}</td>
              <td>{emp.email}</td>
              <td>{emp.phone}</td>
              <td>
                {emp.image_path ? (
                  <img src={`https://attendance-api.elitewebpro.com${emp.image_path}`} width="60" alt="Employee" />
                ) : '—'}
              </td>
              <td>
                {emp.qr_code ? (
                  <img
                    src={`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(emp.qr_code)}&size=80x80`}
                    alt="QR Code"
                  />
                ) : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
